import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function BookingModal({
  isOpen,
  onClose
}: BookingModalProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isOpen && containerRef.current) {
      // Re-initialize Typeform when modal opens
      const win = window as any;
      if (win.tf && win.tf.load) {
        win.tf.load();
      }
    }
  }, [isOpen]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-8">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm" onClick={onClose} data-id="element-9">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-2xl bg-navy rounded-2xl shadow-2xl border border-white/10 overflow-hidden" style={{
        minHeight: '600px'
      }} onClick={e => e.stopPropagation()} data-id="element-10">
            {/* Close Button */}
            <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 bg-navy/80 backdrop-blur-sm rounded-full text-white/60 hover:text-white hover:bg-white/10 transition-colors" aria-label="Close" data-id="element-11">
              <XIcon className="w-5 h-5" data-id="element-12" />
            </button>

            {/* Typeform Embed */}
            <div ref={containerRef} className="w-full h-full" style={{
          minHeight: '600px'
        }} data-id="element-13">
              <div data-tf-live="01KHVYRAJ53TMAXRN2QPKBEPT0" style={{
            width: '100%',
            height: '600px'
          }} data-id="element-14" />
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}